export const containerFormLabels = {
  cargoType: 'Cargo type / 货物类型',
  cbm: 'CBM / 体积',
  containerNumber: 'Container number / 集装箱号',
  description: 'Goods description / 货物描述',
  grossWeight: 'Gross weight / 毛重',
  containerGuidelines: 'Enter information below / 输入下面的信息',
  marksAndNumbers: 'Marks and numbers / 唛头',
  palletType: 'Pallet type / 托盘类型',
  quantity: 'Quantity / 数量',
  sealNumber: 'Seal number / 封条号码',
  submissionSuccess:
    "Cargo details recorded. We'll notify if any additional information is needed. /货物信息已提交。如需补充信息，我们会通知您。",
  hsCodes: 'HS codes / 海关编码'
};

export const containerFormValidations = {
  cargoType: 'Cargo type is required / 货物类型为必填项',
  cbm: 'CBM is required / 需要煤层气',
  cbmGreaterThanZero: 'CBM must be greater than 0 / CBM 必须大于 0',
  containerNumber: 'Container number is required / 需要集装箱号',
  containerValid: 'Container number must be 3 letters, U/J/Z, and 7 digits / 集装箱号码必须由 3 个字母、U/J/Z 和 7 位数字组成',
  description: 'Description is required / 描述为必填项',
  hsCodeAtLeastOne: 'At least one HS code is required / 至少需要一个 HS 代码',
  hsCodeFormat: 'HS code must be a number with at least 6 digits / HS 编码必须是至少 6 位数字',
  marksAndNumbers: 'Marks and numbers are required / 需要唛头',
  quantity: 'Quantity is required / 数量为必填项',
  quantityGreaterThanZero: 'Quantity must be greater than 0 / 数量必须大于 0',
  sealNumber: 'Seal number is required / 封条号码为必填项',
  weightGreaterThanZero: 'Gross weight must be greater than 0 / 毛重必须大于 0',
  weightValue: 'Shipment weight value required / 需要填写货件重量值',
  weightUnit: 'Shipment weight unit required / 需要装运重量单位'
};
